<script lang="ts">
  import TextNew, { type TextSize } from "../TextNew.svelte";
  import Icon from "../icons/Icon.svelte";
  export let selected: boolean = false;
  export let unavailable = false;
  export let title: string;
  export let subtitle: string | undefined = undefined;
  export let titleSize: TextSize = "xs";
</script>

<button on:click>
  <div class="text">
    <TextNew size={titleSize} --rk-text-color={unavailable && "var(--rekki-error)"}>
      {title}
    </TextNew>

    {#if subtitle}
      <TextNew size="xs" --rk-text-color="var(--rk-text-transparency-dark)">
        {subtitle}
      </TextNew>
    {/if}
  </div>

  <div style:visibility={selected ? "visible" : "hidden"}>
    <Icon name="checkmark" --color="var(--rk-text-dark)" />
  </div>
</button>

<style>
  .text {
    text-align: left;
  }
  button {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-radius: var(--rk-rounding-xs);
    padding: 12px;
    gap: 8px;
  }

  button:hover {
    background: var(--rk-divider-0);
  }
</style>
